import React from "react";
import { useLoading } from "../context/LoadingContext";
import { assetBackgroundImage, assetPath } from "../utils/assets";

const GlobalLoader = () => {
    const { loading } = useLoading();

    if (!loading) return null;

    return (
        <div 
            className="fixed top-0 left-0 w-full h-full flex-center bg-black bg-opacity-75 z-100 flex-col"
            style={{
                backgroundImage: assetBackgroundImage("/icons/loading_bg.png"),
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="mb-7">
                <img 
                    src={assetPath("/icons/logo.png")}
                    className="w-[200px]" 
                    alt="Logo" 
                />
            </div>
            <div className="loader"></div>

            {/* Inline Tailwind Animation */}
            <style>
                {`
                    .loader {
                        height: 30px;
                        aspect-ratio: 2.5;
                        --_g: no-repeat radial-gradient(farthest-side, #fff 90%, #0000);
                        background:var(--_g), var(--_g), var(--_g), var(--_g);
                        background-size: 20% 50%;
                        animation: l43 1s infinite linear; 
                    }
                    @keyframes l43 {
                        0%     {background-position: calc(0*100%/3) 50% ,calc(1*100%/3) 50% ,calc(2*100%/3) 50% ,calc(3*100%/3) 50% }
                        16.67% {background-position: calc(0*100%/3) 0   ,calc(1*100%/3) 50% ,calc(2*100%/3) 50% ,calc(3*100%/3) 50% }
                        33.33% {background-position: calc(0*100%/3) 100%,calc(1*100%/3) 0   ,calc(2*100%/3) 50% ,calc(3*100%/3) 50% }
                        50%    {background-position: calc(0*100%/3) 50% ,calc(1*100%/3) 100%,calc(2*100%/3) 0   ,calc(3*100%/3) 50% }
                        66.67% {background-position: calc(0*100%/3) 50% ,calc(1*100%/3) 50% ,calc(2*100%/3) 100%,calc(3*100%/3) 0   }
                        83.33% {background-position: calc(0*100%/3) 50% ,calc(1*100%/3) 50% ,calc(2*100%/3) 50% ,calc(3*100%/3) 100%}
                        100%   {background-position: calc(0*100%/3) 50% ,calc(1*100%/3) 50% ,calc(2*100%/3) 50% ,calc(3*100%/3) 50% }
                    }
                `}
            </style>
        </div>
    );
};

export default GlobalLoader;